(function(window) {
   'use strict';
   
   window.TSC = window.TSC || {};
   window.TSC.playerType = (function() {
      return {
         HTML5_VIDEO: 'html5',
         YOUTUBE: 'youtube',
         IMAGE: 'image',
         TSCPROJ: 'tscproj',
         NOT_SUPPORTED: 'not_supported'
      };
   }());
}(this));
